<template>
  <div class="webpage">
    <iframe :src="url" width="100%" height="100%"></iframe>
  </div>
</template>
  
  
<script>
export default {
  name: 'WebViewComponent',
  data() {
    return {
      url: '',
    };
  },
  mounted() {
    let userinfo = JSON.parse(localStorage.getItem('userinfo'));
    this.url = `https://ke-fu.haocha13.cn/index/index/home?visiter_id=${userinfo?.nickname}&visiter_name=${userinfo?.nickname}&avatar=${userinfo?.avatar}&groupid=0&business_id=1`;
  },
};
</script>
  
  
<style scoped>
iframe {
  border: none;
}
.webpage {
  height: 100vh;
}
</style>